// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Global from '../_raw/ui/icon_global.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Global);
